import { useCallback } from 'react'
import { logger } from '@/lib/logging'
import type { SessionRefs } from './types'
import { closeAudioMixing, stopTracks } from './streamHelpers'

export function useStopAllStreams(
  refs: SessionRefs,
  setIsTimerRunning: (isRunning: boolean) => void
) {
  return useCallback(
    async (cleanupRecording = false) => {
      setIsTimerRunning(false)

      stopTracks(refs.screenStreamRef.current)
      refs.screenStreamRef.current = null
      stopTracks(refs.mediaStreamRef.current)
      refs.mediaStreamRef.current = null
      await closeAudioMixing(refs)

      if (refs.frameIntervalRef.current) {
        clearInterval(refs.frameIntervalRef.current)
        refs.frameIntervalRef.current = null
      }

      if (refs.serviceRef.current) {
        refs.isIntentionallyDisconnectingRef.current = true
        try {
          await refs.serviceRef.current.disconnect()
        } catch (err) {
          logger.error('Error disconnecting service in stopAllStreams', { error: String(err) })
        } finally {
          refs.isIntentionallyDisconnectingRef.current = false
        }
      }

      if (cleanupRecording && refs.recordingManagerRef.current) {
        refs.recordingManagerRef.current.cleanup()
        refs.recordingManagerRef.current = null
      }
    },
    [refs, setIsTimerRunning]
  )
}
